import {
    USER,
    USER_ERROR,
    USER_SUCCESS,
    ADD_USER,
    ADD_USER_ERROR,
    ADD_USER_SUCCESS,
    UPDATE_USER,
    UPDATE_USER_ERROR,
    UPDATE_USER_SUCCESS
} from "../constants/userConstants";


const initialState = {
    loading: false,
    success: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: ''
};


function userReducer(state = initialState, action) {

    switch (action.type) {
        case USER:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': ''

            });
        case USER_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case USER_SUCCESS:
            let userData = action.data ? action.data : undefined;

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'userData': userData

            });
        case ADD_USER:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': ''

            });
        case ADD_USER_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case ADD_USER_SUCCESS:
            const oldUserData = state.userData ? state.userData : [];
            let addData = action.data ? [...oldUserData, action.data] : oldUserData;

            addData.sort((a, b) => (a._id > b._id) ? 1 : -1);

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'userData': addData

            });
        case UPDATE_USER:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': ''

            });
        case UPDATE_USER_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case UPDATE_USER_SUCCESS:
            let updData = (state.userData) ? state.userData.map(item => (item._id === action.data._id) ? action.data : item) : [];

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'userData': updData

            });
        default:
            return state;
    }
};

export default userReducer